import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CookieService {
  /**
   * Retrieves a single cookie by it's name
   *
   * @param  {string} name Identification of the Cookie
   * @returns The Cookie's value
   */
  public get(name: string): string {
    name = encodeURIComponent(name);
    const regexp = new RegExp(
      "(?:^" + name + "|;\\s*" + name + ")=(.*?)(?:;|$)",
      "g"
    );
    const result = regexp.exec(document.cookie);
    return result ? decodeURIComponent(result[1]) : "";
  }
}
